import * as React from 'react'
import * as st from './circlePlayButton.module.scss'
import { getPlaybackClickstreamRef } from '../../utils/getPlaybackClickstreamRef'
import { RecordRefTag } from '@utils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PlayButton } from '../playButton/PlayButton'
import * as cn from 'classnames'
import { fillValues } from 'DVWebNodeUtils'
import { PlayerContext } from '../../../../shared/player/integration/playbackArea'
import { AtfTreatmentProps } from '../../reducers/features'

export interface ICirclePlayButtonProps extends AtfTreatmentProps {
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  isPackshot?: boolean
}

export const CirclePlayButton = ({playbackData, isPackshot, atfTreatment}: ICirclePlayButtonProps) => {

  if (!playbackData) {
    return null
  }

  const classNames = cn(
    st.imagePlayButton,
    isPackshot ? st.packshotButton : undefined
  )

  const label = fillValues(playbackData.label, { lineBreak: ', ' })

  const playbackContent = {
    contentConfig: {
      asin: playbackData.playbackID,
      trailer: false,
      position: playbackData.resumeTime,
      ref: getPlaybackClickstreamRef(
        playbackData.contentType,
        playbackData.entitlementType
      ),
      videoType: playbackData.videoMaterialType,
      useFullView: true,
    },
    signInUrl: playbackData.signInURL,
    playbackUrl: playbackData.playbackURL,
    fallbackUrl: playbackData.fallbackURL,
  }

  return (
    <RecordRefTag refTag='atv_dp_pb_circle'>
      <PlayerContext.Consumer>
        {({ onPlay }) => {
          const onClick = (e: React.MouseEvent) => {
            onPlay(playbackContent)
            e.preventDefault()
          }

          return (
            <PlayButton
              className={classNames}
              href={playbackData.playbackURL}
              isSeeThrough
              isPackshotButton={isPackshot}
              ariaLabel={label}
              onClick={onClick}
              atfTreatment={atfTreatment}
            />
          )
        }}
      </PlayerContext.Consumer>
    </RecordRefTag>
  )
}
